import './cu_admission.css'

import { currencyConverter, formatDate, formatDateAndTime } from '../../../resources/constants';
import React from "react";

const HensardPGAdmissionLetter = (props) =>
{
    const app_det = props.data[0]?.admission?.app_det;
    const app_settings = props.data[0]?.admission?.app_settings[0];
    const admission_letter = props.data[0]?.admission?.admission_letter[0];
    const applicantInfo = props.data[0]?.admission?.applicant_details[0];
    const tuition_fee = props.data[0]?.tuition[0];
    return (
        <div>
            {
                props.data.length > 0 &&
                <div className="body"
                    //      style={{
                    //     backgroundImage: `url(${bgImage})`,
                    //     backgroundRepeat: 'no-repeat',
                    //     backgroundSize: 'cover',
                    //     backgroundColor: 'transparent !important',
                    //     paddingBottom: '10px'
                    // }}
                     ref={props.ref}>
                    <div className="table-wrapper" style={{ marginLeft: "50px", marginRight: "50px", marginTop: "152px"}} >
                        <div>
                            <br />
                            <p className='p-text' style={{ fontSize:"15px"}} >
                                Application ID: APP/{app_det?.AdmissionSemester}/{app_det?.EntryID}
                                <br />
                                Approved Date: {formatDateAndTime(formatDate(app_det?.DecisionDate), "date")}
                                <br />
                                Applicant Name: {applicantInfo.FirstName} {applicantInfo.MiddleName} {applicantInfo.Surname}
                                <br />
                            </p>
                            <div>Dear {applicantInfo.FirstName},</div>
                        </div>
                        <div className="mb-2" style={{ fontWeight: "bolder", textAlign: "center" }}>OFFER OF PROVISIONAL ADMISSION INTO SCHOOL OF
                            POSTGRADUATE STUDIES</div>
                        <div style={{ marginTop: "-5px", fontSize:"15px" }} >
                            Further to your application for admission into the Postgraduate School of Hensard University, I am pleased to inform
                            you that you have been offered Provisional Admission to pursue an academic programme leading to the award
                            of <b>{app_det?.DegreeInView}</b>, <b>{app_det?.DecisionLevel}</b> level in the <b>{app_settings?.AcademicSession}.</b> academic session, due to commence teaching on the <b>{formatDateAndTime(app_settings?.StartDate, "date")}</b>.<br/><br/>
                            <div style={{fontSize:"14px" }}>
                                Tuition for the programme is <b>{currencyConverter(parseInt(tuition_fee?.TuitionAmount))}</b>, plus 50,000 caution and processing fee.
                                for the online payment system (<a href='https://portal.hensarduniversity.edu.ng/payment/' target={"_blank"}>portal.hensarduniversity.edu.ng/payment/</a>). Log in using your Application ID <strong>{app_det?.EntryID}</strong> and registered email <strong>{applicantInfo?.EmailAddress}</strong>.<br/>
                            </div>
                            <br />
                            <div>Please note that this offer of admission is subject to your acceptance of the conditions and undertaking as
                                attached.
                            </div>
                            <br/>
                            <div>Please note, Hensard University reserves the right to assign or reassign you to a course of study different from your
                                first choice, when the need arises. Kindly note that the University reserves the right to amend previously
                                announced fees, if necessary</div>
                            <br />
                            <div> Please accept our congratulations!</div>
                            <img src={require("./reg_sign.png")} style={{ width: "200px", height: '60px', marginTop: '10px' }} />
                            <br />
                            <div className="" style={{ fontWeight: "bolder" }}>
                                Kebiru Umaru, PhD.
                            </div>
                            <p className="">Registrar</p>
                            <br /><br/><br/>
                        </div>
                    </div>
                </div>
            }
        </div >
    )
}
export default HensardPGAdmissionLetter
